import { RProgress } from '@hh.ru/rprogress';

const LinearProgress = () => <RProgress color="#d9000e" />;

export default LinearProgress;
